import { BrandedNotification } from '../enums';
const MODULE_PREFIX = BrandedNotification.BRANDED_NOTIFICATION;
export const BRANDED_NOTIFICATION_GET_SUMMARY_DATA_REQUEST = `${MODULE_PREFIX}_GET_SUMMARY_DATA_REQUEST`;
export const BRANDED_NOTIFICATION_GET_SUMMARY_DATA_SUCCESS = `${MODULE_PREFIX}_GET_SUMMARY_DATA_SUCCESS`;
export const getSummaryDataAction = (brandedNotificationInputs, coCode) => ({
    type: BRANDED_NOTIFICATION_GET_SUMMARY_DATA_REQUEST,
    payload: { brandedNotificationInputs, coCode }
});
export const getSummaryDataSuccessAction = brandedNotificationSummaryData => ({
    type: BRANDED_NOTIFICATION_GET_SUMMARY_DATA_SUCCESS,
    payload: { brandedNotificationSummaryData }
});
//# sourceMappingURL=getSummaryBrandedNotificationAction.js.map